import React from 'react';

export default function TechnoCrownSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="29.69,26.23 2.0,26.23 2.0,9.62 29.69,9.62" fill="#D37225" />
      <polygon points="10.31,30.38 2.0,26.23 2.0,9.62 10.31,13.77" fill="#7C4315" opacity="0.95" />
      <polygon points="38.0,30.38 29.69,26.23 29.69,9.62 38.0,13.77" fill="#7C4315" opacity="0.95" />
      <polygon points="38.0,30.38 10.31,30.38 10.31,13.77 38.0,13.77" fill="#D37225" />
    </svg>
  );
}
